import { cn } from '@bem-react/classname';

export const cnBadge = cn('Badge');
